import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TableBody from './TableBody';
import TableCell from './TableCell';
import TableHeader from './TableHeader';
import TableHeaderCell from './TableHeaderCell';
import TableResponsive from './TableResponsive';
import TableRow from './TableRow';
import TableSortable from './TableSortable';
import TableSortableHeaderCell from './TableSortableHeaderCell';
import { TABLE_SIZES } from '../../constants/TABLE';
import { TableMixin } from '../../mixins/components/TableMixin';
import { TableProvider } from '../../js/TableContext';
export var StyledTable = /*#__PURE__*/styled.table.withConfig({
  displayName: "StyledTable",
  componentId: "c11n-8-64-0__sc-b979s8-0"
})(["", ""], TableMixin);
/**
 * Tables are used to organize data and actions with a logical relationship in grids.
 *
 * @since 8.0.0
 */

var Table = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TableProvider, {
    value: {
      alignments: props.alignments,
      size: props.size
    }
  }, /*#__PURE__*/React.createElement(StyledTable, _extends({
    ref: ref
  }, props)));
});
Table.displayName = 'Table';
Table.propTypes = {
  /**
   * Sets the horizontal alignment for each column.
   * Ex: `['left', 'left', 'center', 'right']`. You can
   * use the `align` prop on individual cells to override.
   */
  'alignments': PropTypes.arrayOf(PropTypes.string),

  /**
   * Styles the table based on one of its preset templates
   */
  'appearance': PropTypes.oneOf(['barebones', 'horizontal', 'grid', 'zebra']),

  /**
   * Be sure to provide a unique, accessible label for the table. This enables people using
   * assistive technologies to identify the purpose of the table and to
   * differentiate among multiple tables on the same page.
   */
  'aria-label': PropTypes.string.isRequired,

  /**
   * The table content
   */
  'children': PropTypes.node.isRequired,

  /**
   * Adjusts the table's density by changing the font size and spacing
   */
  'size': PropTypes.oneOf(Object.keys(TABLE_SIZES))
};
Table.defaultProps = {
  alignments: [],
  size: TABLE_SIZES.md,
  appearance: 'grid'
};
/** @component */

Table.Body = TableBody;
Table.Cell = TableCell;
Table.Header = TableHeader;
Table.HeaderCell = TableHeaderCell;
Table.Responsive = TableResponsive;
Table.Row = TableRow;
Table.Sortable = TableSortable;
Table.SortableHeaderCell = TableSortableHeaderCell;
export default Table;